var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRedeemS(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 1H2.11111H9.88889H11V11H9.88889H2.11111H1V1ZM9.88889 9.88889V2.11111H2.11111V9.88889H9.88889ZM5.44444 3.22222H6.55556V6.55556H7.66667V7.66667H6.55556V8.77778H5.44444V7.66667H4.33333V6.55556H5.44444V3.22222ZM4.33333 5.44444L4.33333 6.55556L3.22222 6.55556V5.44444H4.33333ZM8.77778 5.44444H7.66667V6.55556L8.77778 6.55556V5.44444Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedeemS);
export default __webpack_public_path__ + "static/media/redeem-s.f527c830b32c01c76529a96eb0c4ef80.svg";
export { ForwardRef as ReactComponent };